//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import { EventBus } from './../../events.js';
	import VueRecaptcha from 'vue-recaptcha';
	import Rgpd from "../rgpd/rgpd";

	export default {
		name: 'form-chestnut',
		components: {
			Rgpd,
			'vue-recaptcha': VueRecaptcha
		},
		props: ['captcha', 'url'],
		data() {
			return {
				form: new window.Form({
					title: '',
					user_email: '',
					content: '',
                    capture: null,
					'g-recaptcha-response': '',
					accept_contact_marrons: false,
					token: null,
					form_id: '',
					form_url: '',
				}),
				rgpd: {
					form_id: 'form-marrons',
					user_id: null,
					user_token: null,
					name: 'accept_contact_marrons',
					purpose: 'contact_marrons',
					title: "J'accepte de recevoir une réponse par email",
					text: "Votre adresse email ne sera pas enregistrée dans nos bases de donnée, ni communiquée à des tiers, et ne sera utilisée le cas échéant que pour répondre aux échanges mails sollicités par votre envoi de formulaire.",
					text_consent: "Vous avez déjà donné votre consentement pour que nous utilisions ces données pour apporter une réponse à votre signalement. Votre <strong>adresse email</strong> ne sera pas utilisée à d'autres fins, ne sera pas stockée en base de données et ne servira que pour répondre aux emails sollicités par l'envoi du formulaire."
				},
                capture: null,
			}
		},
		mounted() {
			this.form.form_url = this.url;
			this.form.form_id = this.rgpd.form_id;
			setTimeout(() => {
				this.form.name = User.nickname;
				this.form.email = User.email;
				this.rgpd.user_id = User.id;
				this.rgpd.user_token = User.consentToken;

				this.form.token = User.consentToken;
			}, 1500);

			EventBus.$on('update:consent', data => {
				this.form.accept_contact_marrons = data;
			});

			EventBus.$on('update:consent_token', data => {
				this.form.token = data;
				this.rgpd.user_token = data;
			});

            $('.custom-file-input').on('change', function(e) {
                let fileName = $(this).val().split('\\').pop();
                let label = $(this).siblings('.custom-file-label');

                if (label.data('default-title') === undefined) {
                    label.data('default-title', label.html());
                }

                if (fileName === '') {
                    label.removeClass("selected").html(label.data('default-title'));
                    //this.form.capture = '';
                    //this.capture = '';
                    //console.log(this.form.capture);
                } else {
                    label.addClass("selected").html(fileName);
                    //this.form.capture = e.target.files[0];
                    //this.capture = e.target.files[0];
                    //console.log(e.target.files[0]);
                    //console.log('form capture');
                    //console.log(this.form.capture);
                }
            });
		},
		methods: {
			onVerify(response) {
				this.form['g-recaptcha-response'] = response;
				this.$refs.recaptcha.reset();

				this.form.post('boite-a-marrons', true, true).then(response => {
                    if( response.success ) {
                        window.Notify.success(response.message);
					} else {
                        window.Notify.error('Une erreur est survenue durant l\'envoi de votre message, veuillez réessayer.');
					}
				});
			},

			submit() {
				this.form.token = this.rgpd.user_token;
                console.log(this.form);
				this.$refs.recaptcha.execute();
			},

			resetCaptcha() {
				this.$refs.recaptcha.reset()
			},

			handleFile(e) {
				this.form.capture = e.target.files[0];
			}
		},
	}
